<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Anomalies Produits (contrats ouverts) </strong>
      </b-card-header>
      <b-card-body>
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          class="export-excel-btn mb-2"
          :filename="'export_anomalie_produits_'+getTimestamp()">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </vue-excel-xlsx>
        <table v-if="finished" class="mt-2 w-100" border="1px">
          <thead>
          <tr>
            <td class="prune-medium center p-1"><b>N° Contrat</b></td>
            <td class="prune-medium center nowrap p-1"><b>Type Ano.</b></td>
            <td class="prune-medium p-1"><b>Codes-Produits</b></td>
            <td class="prune-medium nowrap p-1"><b>Famille-Produit</b></td>
            <td class="prune-medium center p-1"><b>Date Effet</b></td>
            <td class="prune-medium center p-1"><b>SIREN</b></td>
            <td class="prune-medium center p-1"><b>NIC</b></td>
            <td class="prune-medium p-1"><b>RS Site Assuré</b></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in anomalieProduit" :key="key">
            <td class="p-1"> {{ element.num_contrat_coll }}</td>
            <td class="p-1"> {{ element.ano_contrat }}</td>
            <td class="p-1"> {{ element.codes_produits }}</td>
            <td class="p-1"> {{ element.lib_fam_produit }}</td>
            <td class="p-1"> {{ formatDate(element.date_effet) }}</td>
            <td class="p-1"> {{ element.siren }}</td>
            <td class="p-1"> {{ element.nic }}</td>
            <td class="p-1"> {{ element.raison_sociale }}</td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "AnomalieProduit",
    data() {
      return {
        anomalieProduit: [],
        finished: false,
        excelColumns: [
          {
            label: "N° Contrat",
            field: "contrat",
          },
          {
            label: "Type Ano.",
            field: "type_ano",
          },
          {
            label: "Codes-Produits",
            field: "codes_produits",
          },
          {
            label: "Famille-Produit",
            field: "famille_produit",
          },
          {
            label: "Date Effet",
            field: "date_effet",
          },
          {
            label: "SIREN",
            field: "siren",
          },
          {
            label: "NIC",
            field: "nic",
          },
          {
            label: "RS Site Assuré",
            field: "raison_sociale",
          },
        ],
        excelData: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.downloadAnomalieProduit();
    },
    methods: {
      downloadAnomalieProduit() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/extractions/anomalie_produit')
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.anomalieProduit = response.data.data;
            this.finished = true;
            for (let row of response.data.data) {
              this.excelData.push({
                contrat: row.num_contrat_coll,
                type_ano: row.ano_contrat,
                codes_produits: row.codes_produits,
                famille_produit: row.lib_fam_produit,
                date_effet: this.formatDate(row.date_effet),
                siren: row.siren,
                nic: row.nic,
                raison_sociale: row.raison_sociale,
              });
            }
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>


